import {
  Component,
} from "react";

import DashboardMenu from "Components/dashboard-menu";
import DashboardTopbar from "Components/dashboard-topbar";
import DashboardFooter from "Components/dashboard-footer";
import Breadcrumb, {
  BreadcrumbRenderer,
} from "CommonComponents/breadcrumb";
import store from "CommonState/store";
import ErrorReporter from "CommonComponents/error-reporter";
import TokenRefresher from "Components/token-refresher";
import {
  renderChildren,
} from "CommonCore/router-util";

@store
export default class DashboardPage extends Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount = () => {
    this.props.retrieveKataloge();
  };

  render() {
    const { location } = this.props;
    return <div>
      <div id='wrapper'>
        <Breadcrumb name='Startseite' path='/' />

        <DashboardMenu location={location} />

        <div id='page-wrapper'>
          <DashboardTopbar location={location} />
          <div id='main'>
            <BreadcrumbRenderer titleFormat='${title} - e-Portal' defaultTitle='Startseite' />
            {renderChildren(this.props)}
          </div>
          <DashboardFooter />
        </div>
      </div>

      <TokenRefresher />
      <ErrorReporter />

    </div>;
  }
}

